import React, {FC, PropsWithChildren, useEffect, useState} from 'react';
import {AvailableStatusesContext} from './AvailableStatusesContext';
import {Option, useSearch} from '../../../../hooks/dropdown/useSearch';
import {STATUS_FIELD} from '../../constants';
import {Form} from '../../../../stores/Form';

export type AvailableStatusesWrapperProps = {
    form: Form;
    records: any[];
};

export const AvailableStatusesWrapper: FC<PropsWithChildren<AvailableStatusesWrapperProps>> = ({
    children,
    form,
    records
}) => {
    const [statuses, setStatuses] = useState<Option[]>([]);

    const [{results: availableStatuses}, searchHandlers] = useSearch(
        form?.getColumnByName(STATUS_FIELD) || undefined
    );

    useEffect(() => {
        const fetchStatuses = async () => {
            if (records && records.length !== 0 && availableStatuses.length === 0) {
                searchHandlers.handleSearchOpen();
            }
        };
        fetchStatuses();
    }, [records, availableStatuses]);

    useEffect(() => {
        setStatuses(availableStatuses);
    }, [availableStatuses]);

    return (
        <AvailableStatusesContext.Provider value={{statuses, setStatuses}}>
            {children}
        </AvailableStatusesContext.Provider>
    );
};
